// the possible roles for users using the web app
export enum UserRole {
  AMMINISTRATORE = 'amministratore',
  OPERATORE = 'operatore'
}

// converts roles to legible labels for the web app
export const getUserRoleLabel = (role) => {
    return userRoleLabels[role] ?? role
}

const userRoleLabels: { [key: string]: string } = {
    [UserRole.AMMINISTRATORE]: "Amministratore",
    [UserRole.OPERATORE]: "Operatore"
}